import { render, staticRenderFns } from "./UjianOnline.vue?vue&type=template&id=bf1671d8&"
import script from "./UjianOnline.vue?vue&type=script&lang=js&"
export * from "./UjianOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports